var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataStores(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 16.875H3.75C3.58429 16.875 3.42529 16.8092 3.30811 16.692C3.19092 16.5747 3.125 16.4158 3.125 16.25V3.75C3.125 3.58421 3.19092 3.42529 3.30811 3.30803C3.42529 3.19084 3.58429 3.125 3.75 3.125H6.25V16.875Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 9.375H13.75C14.0952 9.375 14.375 9.09518 14.375 8.75C14.375 8.40482 14.0952 8.125 13.75 8.125H8.75C8.40482 8.125 8.125 8.40482 8.125 8.75C8.125 9.09518 8.40482 9.375 8.75 9.375Z",
    fill: "#D6D6D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11.875H13.75C14.0952 11.875 14.375 11.5952 14.375 11.25C14.375 10.9048 14.0952 10.625 13.75 10.625H8.75C8.40482 10.625 8.125 10.9048 8.125 11.25C8.125 11.5952 8.40482 11.875 8.75 11.875Z",
    fill: "#D6D6D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 3.75C2.5 3.75 2.5 3.23223 2.86612 2.86612C2.86612 2.86612 3.23223 2.5 3.75 2.5H16.25C16.25 2.5 16.7678 2.5 17.1339 2.86612C17.1339 2.86612 17.5 3.23223 17.5 3.75V16.25C17.5 16.25 17.5 16.7678 17.1339 17.1339C17.1339 17.1339 16.7678 17.5 16.25 17.5H3.75C3.75 17.5 3.23223 17.5 2.86612 17.1339C2.86612 17.1339 2.5 16.7678 2.5 16.25V3.75ZM3.75 3.75V16.25H16.25V3.75H3.75Z",
    fill: "#D6D6D6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 3.125V16.875C5.625 17.2202 5.90482 17.5 6.25 17.5C6.59518 17.5 6.875 17.2202 6.875 16.875V3.125C6.875 2.77982 6.59518 2.5 6.25 2.5C5.90482 2.5 5.625 2.77982 5.625 3.125Z",
    fill: "#D6D6D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataStores);
export default __webpack_public_path__ + "static/media/dataStores.4fff089d9d62d6bd21b9be7ab7527339.svg";
export { ForwardRef as ReactComponent };